import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function Team() {
  const { t } = useTranslation();
  const members = t('team.members', { returnObjects: true }) as Array<{ name: string; role: string; bio: string }>;
  const photos = ["/team/ulum.jpg", "/team/amet.jpg", "/team/gilang.jpg"];

  return (
    <section id="team" className="py-24 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('team.title')}</h2>
          <p className="text-on-surface-variant max-w-xl mx-auto">{t('team.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {members.map((member, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
              className="bg-surface-container-low border border-outline-variant p-8 rounded-xl text-center hover:border-primary-container transition-all"
            >
              <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-6 border-4 border-primary-container">
                <img src={photos[idx]} alt={member.name} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-bold text-on-surface mb-1">{member.name}</h3>
              <p className="text-primary-container text-sm font-medium mb-4">{member.role}</p>
              <p className="text-on-surface-variant text-sm leading-relaxed">{member.bio}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
